<template>
  <div>
    <h1>Настройки</h1>
    <row>
      <transition name="fade">
        <div class="first-overlay" v-if="getUser.need_change_password == 1">
          <div class="content">
            <h3 class="mb-3">Смените временный пароль</h3>
            <span>Это требуется для Вашей же безопасности!</span>
          </div>
        </div>
      </transition>

      <grid-item xs="12" xl="4" mb="15px">
        <general/>
      </grid-item>
      <grid-item xs="12" xl="4" mb="15px">
        <specialization/>
      </grid-item>
      <grid-item xs="12" xl="4">
        <password :need="getUser.need_change_password == 1"/>
      </grid-item>
    </row>
  </div>
</template>

<script>
import Specialization from "@/pages/Cabinet/Master/Settings/Specialization";
import General from "@/pages/Cabinet/Master/Settings/General";
import Password from "@/pages/Cabinet/Master/Settings/Password";
import Row from '../../../../components/grid/Row';
import GridItem from '../../../../components/grid/GridItem';
import {mapGetters} from "vuex";

export default {
  name: 'Settings',
  components: {Row, GridItem, General, Password, Specialization},
  computed: mapGetters(['getUser']),
}
</script>

<style lang="scss" scoped>
h1 {
  display: none;
}

.first-overlay{
  position: fixed;
  top:0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0,0,0,0.6);
  z-index: 300;

  .content {
    color: #fff;
    position: absolute;
    top: 20%;
    left: 40%;

    h3 {
      color: white;
    }
  }
}

@media screen and (max-width: 1170px) {
  h1 {
    font-size: 24px;
    line-height: 32px;
    margin-top: -10px;
    margin-bottom: 15px;
    display: block;
    padding-top: 0;
  }
}
</style>
